import { SET_RUTA } from "../ActionTypes";

export const setRuta = (arrayRuta) => (dispatch) => {
  dispatch({ type: SET_RUTA, payload: arrayRuta });
};
